import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'src/utils/axiosCatalog';

export const getConsumerWorkOrder = createAsyncThunk('/getConsumerWorkOrder', async (WorkOrderId) => {
  const response = await axios.get(`/GetConsumerWorkOrder/${WorkOrderId}`);
  return response.data;
});
export const getWorkBenchWorkCase = createAsyncThunk('/getWorkBenchWorkCase', async (WorkCaseId) => {
  const response = await axios.get(`/GetWorkBenchWorkCase/${WorkCaseId}`);
  return response.data;
});
export const getConsumerWorkOrderPaymentControl = createAsyncThunk('/getConsumerWorkOrderPaymentControl', async (WorkOrderId) => {
  const response = await axios.get(`/GetConsumerWorkOrderPaymentControl/${WorkOrderId}`);
  return response.data;
});
export const getConsumerFeedback = createAsyncThunk('/getConsumerFeedback', async (WorkOrderId) => {
  const response = await axios.get(`/GetConsumerFeedback/${WorkOrderId}`);
  return response.data;
});

export const getConsumer = createAsyncThunk('/getConsumer', async (consumerId) => {
  const response = await axios.get(`/GetConsumer/${consumerId}`);
  return response.data;
});


const workOrderDetailSlice = createSlice({
  name: 'workOrderDetail',
  initialState: {
    loading: false,
    error: '',
  },
  reducers: {
  },
  extraReducers: {
    [getConsumerWorkOrder.pending]: (state) => {
      state.loading = true;
    },
    [getConsumerWorkOrder.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getConsumerWorkOrder.fulfilled]: (state, action) => {
      state.WorkOrderInformation = action.payload;
      state.loading = false;
    },

    [getWorkBenchWorkCase.pending]: (state) => {
      state.loading = true;
    },
    [getWorkBenchWorkCase.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getWorkBenchWorkCase.fulfilled]: (state, action) => {
      state.WorkOrderInformation = action.payload;
      state.loading = false;
    },

    [getConsumerWorkOrderPaymentControl.pending]: (state) => {
      state.loading = true;
    },
    [getConsumerWorkOrderPaymentControl.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getConsumerWorkOrderPaymentControl.fulfilled]: (state, action) => {
      state.WorkOrderInformation = action.payload;
      state.loading = false;
    },

    
    [getConsumer.pending]: (state) => {
      state.loading = true;
    },
    [getConsumer.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getConsumer.fulfilled]: (state, action) => {
      state.consumerInfo = action.payload;
      state.loading = false;
    }
  }
});

export const workOrderDetailActions = workOrderDetailSlice.actions;

export default workOrderDetailSlice;
